import { Box, Typography, useTheme } from '@mui/material';

const StepIcon = (props) => {
  const { active, completed, icon } = props;
  const theme = useTheme(); // Access the theme

  return (
    <Box
      sx={{
        width: 24,
        height: 24,
        borderRadius: "50%",
        backgroundColor: completed || active
          ? theme.palette.primary.main // Use the primary color from the theme
          : "grey",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
      }}
    >
      <Typography variant="body2">{icon}</Typography>
    </Box>
  );
};

export default StepIcon;